import React from 'react';


export default function FooterCom() {

  return (
   <footer className='bg-skin-light py-2 mt-5 mb-0 absolute b-0 w-full' >
    <div className='flex font-semibold font-sans  justify-center items-center py-4'>
    &copy; 2024 Ayush Negi. All rights reserved. <img className='h-10 w-10 ml-6' src="https://d502jbuhuh9wk.cloudfront.net/logos/63877d7ae4b0715e599aa5a1.png?v=19" alt="" />
    </div>

   </footer>
    
  );
}
